export const OFFICE_DOMAIN = 'https://lofty.com'

export const BRANCH_LOWER_TEXT = 'lofty'

export const SUPPORT_EMAIL = 'support@lofty.com'

export const REGION_SHOW_MLS = true



